export const Styles = {
    roundButton: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        border: '3px solid transparent',
        alignItems: 'center'
    },
    squareButton: {
        width: 30,
        height: 30,
        display: 'flex',
        justifyContent: 'center',
        border: '3px solid transparent',
        alignItems: 'center'
    },
    roundButtonDisabled: {
        borderColor: 'rgba(0, 0, 0, 0.23) !important',
        background: 'white !important',
        cursor: 'cursor'
    },
    roundButtonEnabled: {
        cursor: 'pointer'
    },
    dragButton: {
        padding: 5,
        width: 20,
        height: 20
    },
    unitLabel: {
        textAlign: 'center',
        fontSize: 12,
        'user-select': 'none',
        '-moz-user-select': 'none',
        '-khtml-user-select': 'none',
        '-webkit-user-select': 'none',
        '-o-user-select': 'none'
    },
    dragUnitLayer: {
        lineHeight: 20
    },
    dragLayer: {
        position: 'fixed',
        pointerEvents: 'none !important',
        zIndex: 10000,
        left: 0,
        top: 0,
        width: '100%',
        height: '100%'
    }
};
